import React from "react";

const CaretDown = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M3.30783 7.0583C3.36588 7.00019 3.43481 6.95409 3.51068 6.92263C3.58656 6.89118 3.66788 6.87499 3.75002 6.87499C3.83215 6.87499 3.91348 6.89118 3.98936 6.92263C4.06523 6.95409 4.13416 7.00019 4.19221 7.0583L10 12.8669L15.8078 7.0583C15.9251 6.94102 16.0842 6.87514 16.25 6.87514C16.4159 6.87514 16.5749 6.94102 16.6922 7.0583C16.8095 7.17557 16.8754 7.33463 16.8754 7.50048C16.8754 7.66634 16.8095 7.8254 16.6922 7.94267L10.4422 14.1927C10.3842 14.2508 10.3152 14.2969 10.2394 14.3283C10.1635 14.3598 10.0822 14.376 10 14.376C9.91788 14.376 9.83656 14.3598 9.76068 14.3283C9.68481 14.2969 9.61588 14.2508 9.55783 14.1927L3.30783 7.94267C3.24972 7.88463 3.20362 7.8157 3.17217 7.73982C3.14071 7.66395 3.12453 7.58262 3.12453 7.50048C3.12453 7.41835 3.14071 7.33702 3.17217 7.26115C3.20362 7.18527 3.24972 7.11634 3.30783 7.0583Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default CaretDown;
